import React from "react";
import {Col, Form, Input, InputNumber, Row, Select} from "antd";
import {LockOutlined} from "@ant-design/icons";
import dayjs from "dayjs";

import {formItemFullWidth} from "../../assets/styles";

const {Option} = Select;

const CreditCardForm = () => {
    const onCardNumberChange = (e) => {
        let value = e.target.value;
        let number = Number(value);

        if (value.length === 0 || (value.length === 1 && isNaN(number))) {
            return null;
        }

        if (isNaN(number)) {
            if (isNaN(e.target.defaultValue)) {
                return null;
            }
            return Number(e.target.defaultValue);
        }
        return number;
    };

    const generateYearOptions = (numYears) => {
        let items = [];
        let currentYear = dayjs().tz().year();
        for (let i = 0; i < numYears; i++) {
            let year = currentYear + i;
            items.push(
                <Option key={year} value={year}>{year}</Option>
            );
        }
        return items;
    };

    const monthOptions = (
        [
            <Option key="1" value="1">01</Option>,
            <Option key="2" value="2">02</Option>,
            <Option key="3" value="3">03</Option>,
            <Option key="4" value="4">04</Option>,
            <Option key="5" value="5">05</Option>,
            <Option key="6" value="6">06</Option>,
            <Option key="7" value="7">07</Option>,
            <Option key="8" value="8">08</Option>,
            <Option key="9" value="9">09</Option>,
            <Option key="10" value="10">10</Option>,
            <Option key="11" value="11">11</Option>,
            <Option key="12" value="12">12</Option>,
        ]
    );

    const yearOptions = (
        generateYearOptions(10)
    );

    /* Nested FormItem dropdowns requires a bit of manual CSS fixing to align fields */
    const dropdownStyle = {top: '4px'};
    const expiryDateStyle = {marginBottom: 0};

    return <>
        <Form.Item
            name="Card Number"
            label="Card Number"
            rules={
                [{
                    required: true,
                    type: 'number',
                }]
            }
            getValueFromEvent={onCardNumberChange}
        >
            <Input style={{...formItemFullWidth}} addonAfter={<LockOutlined/>} minLength={15} maxLength={16}/>
        </Form.Item>
        <Form.Item
            label="Expiry Date"
            required={true}
            style={expiryDateStyle}
        >
            <Row gutter={[16, {xs: 10, md: 0}]}
            >
                <Col xs={24} md={12}>
                    <Form.Item
                        name="Month"
                        rules={
                            [{
                                required: true,
                            }]
                        }
                        style={dropdownStyle}
                    >
                        <Select placeholder="MM">
                            {monthOptions}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="Year"
                        rules={[{
                            required: true,
                        }]}
                        style={dropdownStyle}
                    >
                        <Select placeholder="YYYY">{yearOptions}</Select>
                    </Form.Item>
                </Col>
            </Row>
        </Form.Item>
        <Form.Item
            name="CVC"
            label="CVC"
            required={true}
            rules={
                [{
                    required: true,
                    min: 3,
                    max: 4,
                    transform: (val) => {
                        if (val === undefined || val === null) {
                            return '';
                        }
                        return val.toString();
                    }
                }]
            }
        >
            <Row gutter={{sm: 0, md: 16}}>
                <Col xs={24} md={12}>
                    <InputNumber placeholder="3 or 4-digit code" maxLength={4} style={{...formItemFullWidth}}/>
                </Col>
            </Row>

        </Form.Item>
    </>;
}

export default CreditCardForm;
